import { useCallback, useEffect, useState } from 'react';
import { Check, CalendarDays, MessageSquare, Reply } from 'lucide-react';
import './Meldingen.css';

function authFetch(url, options = {}) {
  const token = localStorage.getItem('ozel_token');
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    credentials: 'include',
  });
}

const DAG = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
const datumNL = (s) => {
  const d = new Date(`${s}T12:00:00`);
  return `${DAG[d.getDay()]} ${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
};
const wanneer = (s) => new Date(s).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' });

// Berichten en dag-opmerkingen die medewerkers via hun account (/mijn) sturen.
export default function Meldingen({ onChange }) {
  const [list, setList] = useState(null);
  const [alles, setAlles] = useState(false);

  const load = useCallback(() => {
    authFetch(`/api/mw-beheer/meldingen${alles ? '?alles=1' : ''}`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setList(Array.isArray(d) ? d : []))
      .catch(() => setList([]));
  }, [alles]);
  useEffect(() => { load(); }, [load]);

  const gelezen = async (id) => {
    await authFetch(`/api/mw-beheer/meldingen/${id}/gelezen`, { method: 'POST' });
    load(); onChange?.();
  };
  const allesGelezen = async () => {
    await authFetch('/api/mw-beheer/meldingen/alles-gelezen', { method: 'POST' });
    load(); onChange?.();
  };

  const ongelezen = (list || []).filter((m) => !m.gelezen).length;

  return (
    <div className="mld">
      <div className="mld-head">
        <p>Berichten die medewerkers via hun eigen account sturen. Je krijgt ook een WhatsApp op het meldingennummer.</p>
        <div className="mld-actions">
          <label className="mld-toggle"><input type="checkbox" checked={alles} onChange={(e) => setAlles(e.target.checked)} /> Ook oudere tonen</label>
          {ongelezen > 0 && <button type="button" className="mld-btn" onClick={allesGelezen}><Check size={15} /> Alles gelezen</button>}
        </div>
      </div>

      {list === null ? <p className="mld-empty">Laden…</p> : list.length === 0 ? (
        <p className="mld-empty">Nog geen berichten van medewerkers.</p>
      ) : (
        <ul className="mld-list">
          {list.map((m) => (
            <li key={m.id} className={m.gelezen ? 'is-read' : ''}>
              <div className="mld-icon">{m.datum ? <CalendarDays size={18} /> : <MessageSquare size={18} />}</div>
              <div className="mld-body">
                <div className="mld-meta">
                  <strong>{m.naam}</strong>
                  <span className="mld-kind">{m.datum ? `Opmerking bij ${datumNL(m.datum)}` : 'Algemeen bericht'}</span>
                </div>
                <p className="mld-text">{m.tekst}</p>
                <small>{wanneer(m.verstuurd)}{m.gelezen ? ` · gelezen${m.gelezenDoor ? ` door ${m.gelezenDoor}` : ''}` : ''}</small>
              </div>
              <div className="mld-acts">
              {m.waNummer && (
                <a className="mld-btn" href={`https://wa.me/${m.waNummer}?text=${encodeURIComponent(`Hallo ${m.voornaam}, `)}`} target="_blank" rel="noopener noreferrer"
                  onClick={() => { if (!m.gelezen) gelezen(m.id); }}>
                  <Reply size={15} /> Reageren
                </a>
              )}
              {!m.gelezen && (
                <button type="button" className="mld-btn mld-read" onClick={() => gelezen(m.id)} aria-label={`Bericht van ${m.naam} als gelezen markeren`}>
                  <Check size={15} /> Gelezen
                </button>
              )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
